<div *ngIf="tooltipRequired" class="Marginbox__l-regular  Marginbox__r-large invalid-tooltip {{type}} " style="text-transform:none" >
  <span genTooltip [tooltipText]="getTooltipText()" [tooltipPosition]="tooltipPlacement" [tooltipShow]="tooltipShow" class="tooltip-wrapper" >
  <span class="icon__alert Position__absolute fs4"></span>
    <!--<span class="path2 Position__absolute" style="margin-left: 1em"></span>-->
  </span>
</div>
